import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema, wbsDetailsSchema } from '../lib/schemas';

export interface WbsDetails {
  id: string;
  wbsNoLevel5?: string | null;
  wbsNameLevel5?: string | null;
  wbsNoLevel6?: string | null;
  wbsNameLevel6?: string | null;
}

export type WbsDetailsInput = Omit<WbsDetails, never>;

export const wbsDetailsService = {
  async getAll(): Promise<WbsDetails[]> {
    const result = await apiClient.get(apiUrl.wbsDetails(), {
      validate: envelopeSchema('wbs_details', z.array(wbsDetailsSchema)),
      deduplicate: true,
      context: 'getWbsDetails',
    });
    return result.wbs_details;
  },

  async create(row: WbsDetailsInput): Promise<WbsDetails> {
    const result = await apiClient.post(apiUrl.wbsDetails(), row, {
      validate: envelopeSchema('wbs_detail', wbsDetailsSchema),
      context: 'createWbsDetail',
    });
    return result.wbs_detail;
  },

  async update(id: string, row: Omit<WbsDetailsInput, 'id'>): Promise<WbsDetails> {
    const result = await apiClient.put(apiUrl.wbsDetails(id), row, {
      validate: envelopeSchema('wbs_detail', wbsDetailsSchema),
      context: 'updateWbsDetail',
    });
    return result.wbs_detail;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(apiUrl.wbsDetails(id), {
      context: 'deleteWbsDetail',
    });
  },
};
